// QRCodeGenerator.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';

function QRCodeGenerator({ data }) {
    const [qrCodeImage, setQRCodeImage] = useState('');

    useEffect(() => {
        const generateQRCode = async () => {
            try {
                const response = await axios.get(`/generateQRCode?data=${data}`);
                setQRCodeImage(response.data);
            } catch (error) {
                console.error('Error generating QR code:', error);
            }
        };

        if (data) {
            generateQRCode();
        }
    }, [data]);

    return (
        <div>
            {qrCodeImage && <img src={qrCodeImage} alt="QR Code" />}
        </div>
    );
}

export default QRCodeGenerator;



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useLocation } from 'react-router-dom'; // Import the useLocation hook
// import MainLayout from '../../layouts/MainLayout';

// function DonaQRCodeGenerator() {
//     const [qrCodeImage, setQRCodeImage] = useState('');
//     const location = useLocation(); // Use the useLocation hook to access location data

//     useEffect(() => {
//         const generateQRCode = async () => {
//             try {
//                 const data = location.state.donaQRText; // Access the state object from location
//                 const response = await axios.get(`/generateQRCode?data=${data}`);
//                 setQRCodeImage(response.data);
//             } catch (error) {
//                 console.error('Error generating QR code:', error);
//             }
//         };

//         generateQRCode(); // Call the generateQRCode function
//     }, [location]); // Add location to the dependency array

//     return (
//         <MainLayout>
//             <h1 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Your Donation / Campaigns QR Code List</h1>
//             <p className='text-white'>My Data - {location.state.donaQRText}</p> {/* Access state data */}
//             <div>
//                 {qrCodeImage && <img src={qrCodeImage} alt="Dona QR Code" />}
//             </div>
//         </MainLayout>
//     );
// }

// export default DonaQRCodeGenerator;
